import { handleActions } from 'redux-actions';

import * as types from './actionTypes';

const initialState = {
	sort: ['campaign.campaignName', 'orderingClientName'],
	selectedContactId: null,
};

const reducerMap = {
	[types.SELECT_CONTACT]: (state, { payload }) => {
		return {
			...state,
			selectedContactId: state.selectedContactId === payload.id ? null : payload.id,
		};
	},
	[types.CHANGE_SORT]: (state, { payload }) => {
		return {
			...state,
			sort: payload.sort,
		};
	},
	[types.RESET]: () => initialState,
};

export default handleActions(reducerMap, initialState);
